module.exports = __webpack_public_path__ + "static/img/5006_phase_function_Paper_Points.079f8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5006_phase_function_Paper_Points.png
// module id = AMR+
// module chunks = 0